/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRouter = createReactComponent("outline", "router", "IconRouter", [["path", { "d": "M3 13m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 17l0 .01", "key": "svg-1" }], ["path", { "d": "M13 17l0 .01", "key": "svg-2" }], ["path", { "d": "M15 13l0 -2", "key": "svg-3" }], ["path", { "d": "M11.75 8.75a4 4 0 0 1 6.5 0", "key": "svg-4" }], ["path", { "d": "M8.5 6.5a8 8 0 0 1 13 0", "key": "svg-5" }]]);

export { IconRouter as default };
//# sourceMappingURL=IconRouter.mjs.map
